import { useTranslation } from 'react-i18next';
import SVGIcon from '~/components/ui/Icons/SVGIcon';
import { capitalize } from '~/components/utils/text';
import { useLanguageParam } from '~/config/i18n';
import type { HostDataType } from '~/types/userTypes';

type TProps = {
  extraClasses?: string;
  hostData: HostDataType;
};

const AboutTheHost = ({ extraClasses = '', hostData }: TProps) => {
  const { t } = useTranslation();
  const lang = useLanguageParam();

  const spokenLanguagesText = () => {
    let text = '';
    hostData.spokenLanguages[lang].forEach((language, index) => {
      if (index == 0) {
        text += capitalize(language);
      } else if (index == hostData.spokenLanguages[lang].length - 1) {
        text += ` & ${language}`;
      } else {
        text += `,  ${language}`;
      }
    });
    return text;
  };

  return (
    <div className={extraClasses}>
      <h3 className="fo-display-3 -medium mb-6">{t('office.show.aboutTheHost.title')}</h3>

      {hostData.phoneVerified && (
        <div className="d-flex align-items-center mb-3">
          <SVGIcon
            iconType="verified-user-badge"
            className="me-1"
          />
          <span className="text-2 -medium">{t('office.show.aboutTheHost.verifiedHost.label')}</span>
        </div>
      )}

      {hostData.businessSector !== 'unspecified' && (
        <>
          <h4 className="fo-display-5 -medium mb-1">{t('office.show.aboutTheHost.industry.title')}</h4>
          <div className="text-1 color-grey-500 -regular mb-6">
            {t(`office.businessSector.${hostData.businessSector}`)}
          </div>
        </>
      )}

      <h4 className="fo-display-5 -medium mb-1">{t('office.show.aboutTheHost.companySize.title')}</h4>
      <div className="text-1 color-grey-500 -regular mb-6">
        {t('office.show.aboutTheHost.companySize.description', { sizeRange: hostData.companySize })}
      </div>

      <h4 className="fo-display-5 -medium mb-1">{t('office.show.aboutTheHost.teamDescription.title')}</h4>
      <div className="mb-6">
        <div className="text-1 color-grey-500 -regular mb-2">
          {t(`company.details.noise.${hostData.teamDescription.noise}`)}
        </div>
        <div className="text-1 color-grey-500 -regular mb-2">
          {t(`company.details.collaboration.${hostData.teamDescription.collaboration}`)}
        </div>
        <div className="text-1 color-grey-500 -regular mb-2">
          {t(`company.details.workTimings.${hostData.teamDescription.workTimings}`)}
        </div>
        <div className="text-1 color-grey-500 -regular">
          {t(`company.details.style.${hostData.teamDescription.style}`)}
        </div>
      </div>
      {!!spokenLanguagesText() && (
        <>
          <h4 className="fo-display-5 -medium mb-1">{t('office.show.aboutTheHost.spokenLanguages.title')}</h4>
          <div className="text-1 color-grey-500 -regular">{spokenLanguagesText()}</div>
        </>
      )}
    </div>
  );
};

export default AboutTheHost;
